import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import hariLiburService from "../../../services/ref/hariLiburService";
import Cookies from "js-cookie";

export const initialState = {
    loading_hari_libur: false,
    data_hari_libur: [],
    showMessage:false,
    message:'',
}


export const getDataHariLibur = createAsyncThunk('hari_libur/data',async (data, { rejectWithValue }) => {
    try {
        const response = await hariLiburService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})


export const hariLiburSlice = createSlice({
    name: 'hari_libur',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_hari_libur = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataHariLibur.fulfilled, (state, action) => {
                state.loading_hari_libur = false
                state.data_hari_libur = action.payload??[]
            })
            .addCase(getDataHariLibur.pending, (state) => {
                state.loading_hari_libur = true
            })
            .addCase(getDataHariLibur.rejected, (state, action) => {
                state.loading_hari_libur = false
                state.data_hari_libur = action.payload
            })
    },
})

export const {
    showLoading,
} = hariLiburSlice.actions

export default hariLiburSlice.reducer
